import styled from 'styled-components';
export const TodoInputBox= styled.div`
    // padding: 0 0 0 calc(100vw*(58/375));
    position: relative;
    width :calc(100vw*(299/375));
    height :calc(100vw*(43/375)) ;
    border: solid #d9d9d9;
    border-width: 0 calc(100vw*(1/375)) calc(100vw*(1/375)) 0; 
    border-radius: 0 calc(100vw*(5/375)) calc(100vw*(5/375)) 0;
    display:flex;
    overflow:hidden;

`
export const TodoInput= styled.input`
    width: calc(100vw*(239/375));
    height: 100%;
    border-left: 1px solid #d5d5d5;
    padding: 0  calc(100vw*(14.5/375));
    font-size: calc(100vw*(14/375));
    font-weight: 500;
    color: #ff9300;

    &::placeholder {
        font-size: calc(100vw*(12/375));
        font-weight: normal;
        color: #c6c6c6;
    }
`
export const Dotbtn = styled.a`
    width: calc(100vw*(3/375));
    height: calc(100vw*(15/375));
`
export const Dotbtnbox = styled.p`
    padding-left : calc(100vw*(12/375));
    width: calc(100vw*(3/375));
    height: calc(100vw*(15/375));
`
export const TodoinputInner = styled.div`
    display: flex;
    align-items: center;
`
export const Timetxt = styled.span` 
    display: inline-block;
    width:  calc(100vw*(60/375));
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    color: #ff9300;
    font-weight: bold;
    font-size:  calc(100vw*(12/375));
    text-align: center;
    line-height:  calc(100vw*(41/375));
`